@let currentField = getCurrentField();

<card-base 
    [field]="field()" 
    [favoriteField]="favoriteField()" 
    [trashField]="trashField()" 
    [type]="type()"
    [selected]="selected()"
    [dynamicActions]="videoActions">

    <!-- Botão de paleta do rail: "Vídeo" (tamanho da miniatura, enquadramento e mostrar no PDF).
         Só no editor (lixeira/favoritos não editam). -->
    @if (type() === 'default') {
        <media-look-chip
            card-toolbar
            kind="video"
            [itemId]="currentField?._id"
            [size]="videoSize()"
            [fullImage]="isFullImage()"
            [fillColor]="fillColor()"
            [showVideo]="showVideo()"
            [captionStyle]="captionStyle()"
            [captionSide]="captionSide()"
            [canRestore]="lookOverridden()"
            [disabled]="editDataService.documentIsBlocked()"
            (chooseSize)="setVideoGrid($event.grid)"
            (captionStyleChange)="setCaptionStyle($event)"
            (captionSideChange)="setCaptionSide($event)"
            (fullImageChange)="setLook('fullImage', $event, false)"
            (fillPreview)="previewFill($event)"
            (fillColorChange)="setFill($event)"
            (showVideoChange)="setLook('showVideo', $event, true)"
            (restore)="restoreLook()"
        />
    }

    <!-- Vídeo e legenda: o estilo da legenda e a descrição ao lado espelham a folha do PDF
         (configs captionStyle e captionPosition). Ao lado, o player fica com meia coluna. -->
    <div
        class="media-figure"
        [class.style-figure]="captionStyle() === 'figure'"
        [class.style-band]="captionStyle() === 'band'"
        [class.side]="captionSide()">
        <div class="media-body">
            <!-- O player acompanha o tamanho da miniatura (1 a 3), como a imagem única: a
                 folha mostra o que sai no PDF. Ao lado da descrição, quem manda é a coluna. -->
            <!-- Faixa da cor do fundo (config imageFillColor) em volta do player: com a
                 miniatura reduzida (Média, Pequena) o player fica centralizado nela, como a
                 foto única e a miniatura no PDF. No tamanho grande, ao lado da descrição ou
                 sem cor, a faixa não aparece. -->
            <div
                class="video-stage"
                [class.banded]="banded()"
                [style.--media-fill]="fillStyle()">
                <div
                    class="container-image"
                    sizeMorphMedia="video"
                    [sizeMorph]="videoSize().grid + (captionSide() ? ':side' : '')"
                    [class.size-2]="!captionSide() && videoSize().grid === 2"
                    [class.size-3]="!captionSide() && videoSize().grid === 3"
                    [class.full]="isFullImage()"
                    [style.--media-fill]="fillStyle()">
                    <video controls controlsList="nodownload" [preload]="'metadata'" [src]="currentField.value"
                        [attr.poster]="currentField.thumbUrl ?? null" [muted]="false">
                    </video>
                </div>
            </div>

            <!-- O vídeo já toca; o que falta é a versão otimizada, a capa e a duração, que o
                 worker produz em até um minuto. Fica no card, logo abaixo do player, e diz
                 o que está acontecendo (um "Processando..." solto não dizia nada). -->
            @if (isProcessing()) {
                <div class="video-processing" role="status" animate.enter="video-processing-enter">
                    <span class="video-processing-spinner" aria-hidden="true"></span>
                    <div class="video-processing-text">
                        <strong>{{ 'document.edit.videoCard.processing' | translate }}</strong>
                        <span>{{ 'document.edit.videoCard.processingHint' | translate }}</span>
                    </div>
                </div>
            }
        </div>

        <div class="media-caption">
            <!-- Description -->
            <card-description-area [field]="currentField" [readonly]="type() !== 'default'" />
        </div>
    </div>
</card-base>

